import { jsonPost } from '../json-request';
import type { ValidatedApiClient } from '../types/api-client';
import {
    BOOST_DEBUG_GRANT_API_PATH,
    BOOST_QUEUE_API_PATH,
    BOOST_REDEEM_API_PATH,
    BOOST_REFERRALS_NOTIFIED_API_PATH,
} from './constants';
import {
    type BoostGrantDebugRequest,
    type BoostQueueRequest,
    type BoostRedeemRequest,
    type BoostReferralsNotifiedRequest,
    boostBalanceResponseSchema,
    boostGrantDebugResponseSchema,
    boostQueueResponseSchema,
    boostRedeemResponseSchema,
    boostReferralsNotifiedResponseSchema,
} from './schema';

export const createBoostsApi = ({ validatedFetch }: ValidatedApiClient) => ({
    getBalance: (signal?: AbortSignal) =>
        validatedFetch(boostBalanceResponseSchema, '/v3/account', new URLSearchParams(), { signal }),

    redeem: ({ kind }: BoostRedeemRequest) =>
        validatedFetch(boostRedeemResponseSchema, BOOST_REDEEM_API_PATH, new URLSearchParams(), jsonPost({ kind })),

    grantDebug: ({ amount }: BoostGrantDebugRequest) =>
        validatedFetch(
            boostGrantDebugResponseSchema,
            BOOST_DEBUG_GRANT_API_PATH,
            new URLSearchParams(),
            jsonPost({ amount }),
        ),

    getQueue: ({ filter, page = 1, perPage = 25 }: BoostQueueRequest) =>
        validatedFetch(
            boostQueueResponseSchema,
            BOOST_QUEUE_API_PATH,
            new URLSearchParams({ filter, page: String(page), perPage: String(perPage) }),
        ),

    /** Marks referral completions as shown, so the account stops listing them as pending. */
    acknowledgeReferralNotifications: ({ ids }: BoostReferralsNotifiedRequest) =>
        validatedFetch(
            boostReferralsNotifiedResponseSchema,
            BOOST_REFERRALS_NOTIFIED_API_PATH,
            new URLSearchParams(),
            jsonPost({ ids }),
        ),
});

export type BoostsApi = ReturnType<typeof createBoostsApi>;
